import React from 'react'

import scrollUtils from '../../../util/scroll'

import ResumoAssociado from '../EspacoMedico/Resumo'

import { Container } from './styles'

import logo from '../../../assets/images/logo-dark.png'

export default function Dashboard({ profile, location }) {
    scrollUtils.toTop()

    return (
        <Container>
            {![2, 16, 21, 22].includes(profile) ? (
                <>
                    <img src={logo} alt="" className="animated fadeInUp faster object-contain" />

                    <h1 className="animated fadeInUp faster delay-600ms text-slate-800">Seja bem-vindo!</h1>
                </>
            ) : (
                <ResumoAssociado showContribuicoes={!!new URLSearchParams(location.search).get('contribuicoes')} />
            )}
        </Container>
    )
}
